import { COLORS, Ic, ICONS } from "@/lib/theme";

import { isPhoneApp } from "@/lib/phoneApp";

export default function TabBar({ tab, onSelect }) {
  const tabs = [
    ["home", "Home", ICONS.home],
    isPhoneApp ? ["ai", "Ask Rabbi AI", ICONS.chat] : ["times", "Times", ICONS.clock],
    ["give", "Give", ICONS.heart],
    ["community", "Community", ICONS.people],
    ["more", "More", ICONS.grid],
  ];
  return (
    <div
      data-testid="tab-bar"
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: 78,
        background: "#fff",
        borderTop: "1px solid " + COLORS.border,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-around",
        paddingTop: 9,
        zIndex: 25,
        boxShadow: "0 -6px 20px rgba(91,42,130,0.06)",
        paddingBottom: "env(safe-area-inset-bottom, 0)",
      }}
    >
      {tabs.map(([k, label, d]) => {
        const on = tab === k;
        if (k === "give") {
          return (
            <button
              key={k}
              data-testid={`tab-${k}`}
              onClick={() => onSelect(k)}
              className="no-tap-highlight"
              style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", marginTop: -22 }}
            >
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.goldLight})`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 8px 18px rgba(201,162,75,0.5)",
                  border: "4px solid #fff",
                }}
              >
                <Ic d={d} color="#fff" size={26} w={2} />
              </div>
              <span style={{ fontSize: 11, fontWeight: 800, color: COLORS.gold, marginTop: 3 }}>{label}</span>
            </button>
          );
        }
        return (
          <button
            key={k}
            data-testid={`tab-${k}`}
            onClick={() => onSelect(k)}
            className="no-tap-highlight"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              opacity: on ? 1 : 0.55,
            }}
          >
            <Ic d={d} color={on ? COLORS.purple : "#9a8ea6"} size={24} w={on ? 2.1 : 1.8} />
            <span style={{ fontSize: 11, fontWeight: on ? 800 : 600, color: on ? COLORS.purple : "#9a8ea6" }}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
